import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import {
  groupMatchesLoser,
  groupRounds,
  toMatchPairs,
  convertToMatchCellProps,
  toColumnsLoser,
} from 'src/components/tournaments/brackets/util/bracketFunctions';
import { useMemo } from 'react';

export const useGenerateBracketLoser = (rounds, Match) => {
  const [roundsLeft, roundsRight, roundsCenter] = groupRounds(rounds);

  const matchesLeftGrouped = groupMatchesLoser(roundsLeft);
  const matchesRightGrouped = groupMatchesLoser(roundsRight);
  const matchesCenterGrouped = groupMatchesLoser(roundsCenter);
  const matchesMobileGrouped = groupMatchesLoser(rounds);

  const matchesLeftProps = convertToMatchCellProps(matchesLeftGrouped, Match);
  const matchesRightProps = convertToMatchCellProps(matchesRightGrouped, Match);
  const matchesCenterProps = convertToMatchCellProps(
    matchesCenterGrouped,
    Match,
    true,
  );

  const matchesMobileProps = convertToMatchCellProps(
    matchesMobileGrouped,
    Match,
    true,
  );

  const matchPairsLeft = toMatchPairs(matchesLeftProps);
  const matchPairsCenter = toMatchPairs(matchesCenterProps);
  const matchPairsRight = toMatchPairs(matchesRightProps);

  const matchColumnsLeft = toColumnsLoser(
    matchPairsLeft,
    rounds.length,
    'left',
  );
  const matchColumnsCenter = toColumnsLoser(
    matchPairsCenter,
    rounds.length,
    'center',
  );
  const matchColumnsRight = toColumnsLoser(
    matchPairsRight.reverse(),
    rounds.length,
  );

  const mobileColumns = useMemo(() => {
    const matchesMobileFixed: { matchId: string; match: JSX.Element }[][] = [];
    matchesMobileProps.reduce((prev, curr) => {
      prev.push(
        curr.matches.slice(0, curr.matches.length / 2),
        curr.matches.slice(curr.matches.length / 2),
      );
      return prev;
    }, matchesMobileFixed);
    return matchesMobileFixed.map((column) => {
      const addSpace =
        (matchesMobileFixed.length > 6 && column.length === 4) ||
        column.length === 2;
      const addSpaceExtra =
        matchesMobileFixed.length > 6 && column.length === 2;
      return (
        <Stack
          direction="column"
          alignItems={'center'}
          justifyContent={addSpace ? 'space-between' : 'center'}
          key={column[0].matchId}
          spacing={4}
          my={addSpace ? '48px !important' : 0}
          pt={addSpaceExtra ? '92px !important' : 0}
          pb={addSpaceExtra ? '96px !important' : 0}
        >
          {column.map((matchObj) => {
            return <Box key={matchObj.matchId}>{matchObj.match}</Box>;
          })}
        </Stack>
      );
    });
  }, [matchesMobileProps]);

  return {
    mobileColumns,
    matchColumnsLeft,
    matchColumnsCenter,
    matchColumnsRight,
  };
};
